import { useState, useEffect, useRef } from 'react';

const useBarcodeScanner = () => {
  const [barcode, setBarcode] = useState('');
  const buffer = useRef('');
  const timeout = useRef(null);

  useEffect(() => {
    const handleKeyDown = (event) => {
      const tag = event.target.tagName;
      if (tag === 'TEXTAREA' || (tag === 'INPUT' && event.target.type === 'text')) {
        buffer.current = '';
        return;
      }

      if (timeout.current) clearTimeout(timeout.current);

      if (event.key === 'Enter') {
        event.preventDefault();
        const scannedCode = buffer.current;
        buffer.current = '';
        setBarcode('');
        setTimeout(() => setBarcode(scannedCode), 0);
      } else if (/^[0-9]$/.test(event.key)) {
        buffer.current += event.key;
      }

      timeout.current = setTimeout(() => {
        buffer.current = '';
        setBarcode('');
      }, 500);
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return barcode;
};

export default useBarcodeScanner;
